/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, Result } from 'antd';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ResponsiveContainer from '../components/ResponsiveContainer';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';

const RegenerarToken = () => {
  const [isRegenerado, setisRegenerado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [datosContactoCensurado, setDatosContactoCensurado] = useState('');
  const location = useLocation();

  useEffect(() => {}, [isRegenerado]);

  const regenerarToken = async () => {
    setLoading(true);
    const searchParams = new URLSearchParams(location.search);
    const tokenExpirado = searchParams.get('tokenExpirado');
    const flujo = searchParams.get('flujo');
    try {
      const response = await instanceRef.instance.post(
        `/tokenExpirables/regenerar-from-token-expirado?flujo=${flujo}&tokenExpirado=${tokenExpirado}`
      );
      if (response.data) {
        setDatosContactoCensurado(response.data.message);
        setisRegenerado(true);
        setLoading(false);
      }
    } catch (err) {
      errorHandler(err, 'Error al cargar la solicitud');
      setLoading(false);
    }
  };

  const getSubTitle = () => {
    let textoEmail = null;
    let textoSMS = null;
    if (datosContactoCensurado.emailCensurado) {
      textoEmail = `un e-mail a la dirección ${datosContactoCensurado.emailCensurado}`;
    }
    if (datosContactoCensurado.phoneCensurado) {
      textoSMS = `un SMS al nro. ${datosContactoCensurado.phoneCensurado}`;
    }
    if (textoEmail && textoSMS) {
      return `Recibirá ${textoEmail} y ${textoSMS} con un nuevo enlace a su solicitud`;
    }
    if (textoEmail && !textoSMS) {
      return `Recibirá ${textoEmail} con un nuevo enlace a su solicitud`;
    }
    if (!textoEmail && textoSMS) {
      return `Recibirá ${textoSMS} con un nuevo enlace a su solicitud`;
    }
    return `No hay información disponible para enviar`;
  };
  return (
    <>
      {isRegenerado === false && (
        <ResponsiveContainer>
          <Card
            style={{
              margin: '0 auto',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Result
              status="info"
              title="Enlace expirado"
              subTitle="El enlace al que intentó acceder ya no es válido."
              extra={[
                <Button
                  loading={loading}
                  type="primary"
                  key="console"
                  onClick={regenerarToken}
                >
                  Regenerar enlace
                </Button>
              ]}
            />
          </Card>
        </ResponsiveContainer>
      )}
      {isRegenerado === true && (
        <ResponsiveContainer>
          <Result
            status="success"
            title="¡Se envió un nuevo enlace!"
            subTitle={getSubTitle()}
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => window.open(window.location.origin)}
              >
                Ir al inicio
              </Button>
            ]}
          />
        </ResponsiveContainer>
      )}
    </>
  );
};

export default RegenerarToken;
